var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ma-2",attrs:{"color":"warning","fab":""},domProps:{"textContent":_vm._s(_vm.points)},on:{"click":function($event){return _vm.onClick(_vm.points)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }